<template>
    <!-- 影像服务路由 -->
    <router-view></router-view>
</template>

<script>
export default {
    
}
</script>
